import React, { Component } from 'react'

class ErrorBoundary extends Component {
  constructor (props) {
    super(props);
    this.state = { error: null, info: null }
  }

  componentDidCatch (error, info) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      info
    })
  }

  render () {
    if (this.state.info) {
      // Error path
      return (
        <React.Fragment>
          <h2>Ocorreu um erro inesperado.</h2>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br/>
            {this.state.info.componentStack}
          </details>
        </React.Fragment>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
